$(document).on('click', '.faq__question', function () {
    let parent = $(this).parent('.faq__item');

    $(this).next().slideToggle('fast', function () {
        if ($(parent).hasClass('faq-open')) {
            $(parent).removeClass('faq-open').addClass('faq-close');
        } else {
            $(parent).removeClass('faq-close').addClass('faq-open');
        }
    });
});
